// extracted by mini-css-extract-plugin
export default {"follow":"memeUserInfoFollow_follow__Bp6zP","followBtn":"memeUserInfoFollow_followBtn__9e1cR","followBtnSelected":"memeUserInfoFollow_followBtnSelected__t4Agd"};